import gql from 'graphql-tag';

export const GET_PARTNERS_PROPOSALS_WITH_PAGINATION = gql`
  query GetPartnersProposalsWithPagination($input: ProposalsWithPaginationInput!) {
    partnersProposalsWithPagination(input: $input) {
      page
      total
      perPage
      totalPages
      data {
        id
        status
        lastName
        firstName
        businessName
        amountRequested
        createdDateTime
        account {
          name
          dynamicsAccountId
        }
        lead {
          inboundDealType
        }
      }
    }
  }
`;
